export default {
  action_message_examples: {
    to: 'Til',
    email: 'bedrift@eksempel.no',
    subject: 'Emne',
  },
  consent_modal: {
    title: 'Samtykkeinnstillinger',
    text: 'Dette nettstedet bruker informasjonskapsler og andre sporingsteknologier for å forbedre nettleseropplevelsen din for følgende formål: for å aktivere grunnleggende funksjonalitet på nettstedet, for å gi en bedre opplevelse på nettstedet, for å måle din interesse for våre produkter og tjenester og for å tilpasse markedsføringsinteraksjoner, for å levere annonser som er mer relevante for deg.',
    preferencesTitle: 'Personvernet ditt er viktig for oss',
    preferencesDescription: 'Velg dine preferanser.',
    preferencesText: '<p>Informasjonskapsler er svært små tekstfiler som lagres på datamaskinen din når du besøker et nettsted. Vi bruker informasjonskapsler til en rekke formål og for å forbedre din nettopplevelse på nettstedet vårt.</p><p>Du kan endre innstillingene dine og avslå at visse typer informasjonskapsler lagres på datamaskinen din mens du surfer på nettstedet vårt. Du kan også fjerne informasjonskapsler som allerede er lagret på datamaskinen din, men husk at sletting av informasjonskapsler kan hindre deg i å bruke deler av nettstedet vårt.</p>',
    alwaysEnabled: 'Alltid aktiv',
    btnPreferences: 'Innstillinger',
    btnAccept: 'Tillatt',
    btnAcceptAll: 'Tillatt alle',
    btnAcceptChoosen: 'Tillatt utvalgte',
    btnDeclineAll: 'Avvis alle',
    essential: 'Nødvendig',
    essentialText: 'Nødvendig for å aktivere grunnleggende nettsidefunksjonalitet. Du kan ikke deaktivere viktige informasjonskapsler.',
    functionality: 'Funksjonalitet',
    functionalityText: 'Disse informasjonskapslene brukes for å gi deg en mer personlig opplevelse på nettstedet vårt og for å huske valg du gjør når du bruker nettstedet vårt.',
    advertising: 'Markedsføring',
    advertisingText: 'Brukes til å levere reklame som er mer relevant for deg og dine interesser. Kan også brukes til å begrense antall ganger du ser en annonse og måle effektiviteten til reklamekampanjer. Annonseringsnettverk plasserer dem vanligvis med nettstedsoperatørens tillatelse.',
    analytics: 'Statistikk',
    analyticsText: 'Hjelp nettstedoperatøren med å forstå hvordan nettstedet fungerer, hvordan besøkende samhandler med nettstedet, og om det kan være tekniske problemer.',
  },
  footer: {
    org_nr: 'Org.nr.',
    account_nr: 'Kontonr.',
  },
  modal_email_confirmed: {
    title: 'Takk for at du bekreftet e-posten din{name}!',
    text: 'Og nå er det tid for handling, la sannheten om turbokyllingen komme frem.',
    btn_close: 'Jeg vil hjelpe fuglene',
  },
  form_donate: {
    modal_redirect: {
      title: 'Ble du ikke videreført til neste side?',
      description: 'Trykk på knappen under for å godkjenne avtalen og fullføre.',
      btn_next: 'Godkjen avtalen',
    },
  },
  modal_donation_error: {
    title: 'En feil oppstod',
    description: 'Venligst prøv igjen, vi jobber med å fikse problemet.',
    text: 'En feil oppstå med donasjonen din, prøv på nytt. Kontakt oss på {email} om problemet fortsetter.',
    btn_next: 'Prøv igjen',
  },
  modal_donation_success: {
    title: 'Takk for bidraget ditt { name }!',
    text: 'Det er takket være folk som deg at vi kan gjøre den jobben vi gjør. Du gjør en forskjell!',
    btn_close: 'Fortsett',
  },
  faq: {
    title: 'Spørsmål og svar',
  },
  impact: {
    title: 'Hvordan vil ditt faste bidrag påvirke dyrene?',
    description: 'Du har makten til å sikre at dyr i Norge har en stemme og at spørsmålet rundt deres vern ikke blir glemt. Din støtte vil tillate:',
    nr1: '1. At vi produserer dokumentasjon og faktadokumenter om dyrenes lidelse.',
    nr2: '2. Kampanjer for å opplyse det norske folk og få frem en offentlig debatt.',
    nr3: '3. Dialog med politikere for å få de til å ta tydlige standpunkt og handle på problemet.',
    nr4: '4. Press på industrien slik at de endrer praksisen.',
  },
  write_guide: {
    examples: 'Tekst eksempler',
    tips: 'Tips og triks',
    why: 'Hvorfor skrive til bedrifter?',
    why_text: 'Bedrifter er interessert i kundenes meninger. Skriv til dem og vis din misnøye. Ved å skrive til bedrifter, kan du direkte påvirke deres beslutninger og praksis. Når mange mennesker uttrykker sin bekymring for dyrevelferd, blir bedrifter tvunget til å lytte og gjøre endringer. Din stemme kan bidra til å forbedre levekårene for millioner av dyr. Ved å delta i denne innsatsen, viser du bedrifter at forbrukerne bryr seg om hvordan dyrene behandles, og at det er et marked for produkter som er produsert på en etisk måte.',
  },
  donateReasons: {
    title: '3 grunner til å gi et fast bidrag',
    reason1: '1. Du vil sikre et bedre liv for de dyrene som lider mest i Norge.',
    reason2: '2. Du vil sørge for at seirene for dyrene ikke stopper.',
    reason3: '3. Du vil sørge for at andre lærer det du har visst lenge.',
  },
  donateTestimonies: {
    title: 'Vi tar kampen sammen',
  },
  donateContactPerson: {
    title: 'Din kontaktperson',
    phone: 'Telefon',
  },
  modalReturnError: {
    title: 'En feil har oppstått',
    description: 'Det oppsto en feil, handling ble ikke fullført. Kontakt oss på {email} om feilen.',
    btnContinue: 'Fortsett',
  },
  actionModalConfirm: {
    titleShare: 'Har du delt nettsiden?',
    titleContact: 'Har du skrevet til {name}?', // via {platform}
    titleOther: 'Er du ferdig?',
    description: 'Det er viktig at du bekrefter handlingen din, ellers blir kampanjen mindre effektiv!',
    btnYes: 'Ja',
    btnNo: 'Nei',
  },
  actionEmail: {
    btnOpenDefault: 'Send e-post',
    btnOpen: 'Send e-posten i {client}',
  },
  actionSocialMedia: {
    btnOpen: 'Skriv på {platform}',
  },
  actionCounterContact: '{emails} e-poster og {some} kommentarer og meldinger på sosiale medier har allerede blitt skrevet. Nå er det din tur {name}!',
  actionCounterShare: '{count} har allerede delt kampanjen, nå er det din tur {name}.',
}
